import React, { useState, useMemo } from "react";
import { createPortal } from "react-dom";

import { ModalContext } from "./ModalContext";
import { Modal } from "./Modal";
import "./Modal.scss";

let modalSetter;

export const openModal = (content, cross = false) => {
  modalSetter({
    open: true,
    content: content,
    cross: cross,
  });
};
export const closeModal = () => {
  modalSetter({
    open: false,
    content: <></>,
  });
};

export const ModalProvider = (props) => {
  const [modal, setModal] = useState({
    open: false,
    content: () => <></>,
  });
  modalSetter = setModal;
  const opener = (content, cross = false) =>
    setModal({ open: true, content: content, cross: cross });
  const closer = () => setModal({ open: false, content: () => <></> });
  const contextValue = useMemo(() => ({ opener, closer }), []);

  return (
    <ModalContext.Provider value={contextValue}>
      {props.children}

      {createPortal(
        modal.open === true ? (
          <div className="overlay">
            <Modal cross={modal.cross} close={closer}>
              {modal.content}
            </Modal>
          </div>
        ) : null,
        document.body
      )}
    </ModalContext.Provider>
  );
};
